import { Vehicle } from '../../vehicleCharging/types';
import { mapAsset } from './AssetMapper';

export const mapAssetList = (assetList: object[]): Vehicle[] => {
    return assetList.map((asset: any) => {
        return mapAsset(asset);
    });
};
